import { useEffect } from 'react'
import { useResizeDetector } from 'react-resize-detector'

import { GraphType, GraphDefaultProps, GraphRender } from '../common'
import { useMultiPieGraphOption, MultiPieGraphOptions } from './container/options'
import { useMultiPieGraphModel } from './container/model'
import { useMultiPieGraphRenderOption } from './container/render'
import { useMultiPieGraphEvents } from './container/event'

import ReactEChartsCore from 'echarts-for-react/lib/core'
import * as echarts from 'echarts/core'
import { PieChart } from 'echarts/charts'
import { TitleComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'

import {
  TooltipComponent,
  GridComponent,
  LegendComponent,
  DataZoomComponent,
} from 'echarts/components'

import { Box } from '@mui/material'

echarts.use([
  TooltipComponent,
  GridComponent,
  LegendComponent,
  PieChart,
  TitleComponent,
  DataZoomComponent,
  CanvasRenderer,
])

export const MultiPieGraph = <T,>({
  dashBoard,
  targetList,
  dataList,
  conditions,
  onChangeCondition,
  itemData,
  isResizing,
  graphRef,
  setCsv
}: GraphDefaultProps<T>) => {
  const { options, filterText } = itemData
  const { width, height, ref } = useResizeDetector()

  const graphOption = useMultiPieGraphOption({ options, dashBoard, targetList })
  const graphData = useMultiPieGraphModel({ dataList, conditions, filterText, graphOption })
	const renderOption = useMultiPieGraphRenderOption({ graphOption, graphData })
  const events = useMultiPieGraphEvents({ graphOption, onChangeCondition })

  const { axisDef, valueDef } = graphOption
	useEffect(
		() => setCsv({ builder: () => graphData?.csvBuilder() }),
    [graphData, setCsv]
  )
  return (
    <Box ref={ref} width="100%" height="100%">
      <GraphRender
        dashBoard={dashBoard}
        keys={[axisDef?.key, valueDef?.key]}
        invalid={!graphData || isResizing || ((height ?? 0) <= 10)}
      >
        {(width && height) ? (
          <ReactEChartsCore
            ref={graphRef}
            echarts={echarts}
            notMerge={true}
            onEvents={events}
            option={renderOption}
            opts={{ renderer: 'canvas' }}
            style={{ width, height }}
            theme="insite"
          />
        ) : <></>}
      </GraphRender>
    </Box>
  )
}

export const MultiPieGraphFactory: GraphType = {
  title: '円グラフ（複数）',
  options: MultiPieGraphOptions,
  element: <T,>(props: GraphDefaultProps<T>) => <MultiPieGraph<T> {...props} />,
}
